var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-header-image",style:(("background-image: url('" + (_vm.$store.state.baseUrl) + _vm.image + "')"))})}
var staticRenderFns = []

export { render, staticRenderFns }